module.exports = __webpack_public_path__ + "img/online-teacher-logo.9fa90092.png";